import { Ref, useEffect, useState } from 'react'
import CustomDropdown from '../dropdown/Dropdown'
import { yupResolver } from '@hookform/resolvers/yup';

import { Modal } from './Modal';
import { HeaderModal } from './Header';
import { Body } from './Body';
import { FooterModal } from './Footer';

import allImgPaths from 'assets/images';
import { useForm } from 'react-hook-form';
import { completeTaskSchema } from 'schema/validation';
import useAppState from 'context/useAppState';
import { useParams } from 'react-router-dom';
import { CARD_STATUS } from 'utils/constant';


function MarkComplete({ setisShowMarkComplete, task_id }: any) {

	const { id } = useParams();
	const { currentEventId } = useAppState('boardData');
	const { currentSelectedTask, updateTask } = useAppState('taskHook');
	const { boardData, updateBoardCallApiFlag, cards: cardList,
		columns,
		updateState } = useAppState('cardWrapper');
	const { setState: setEventData } = useAppState('eventData');
	const [reasonValue, setReasonValue] = useState<any>(null)

	const {
		control,
		setValue,
		handleSubmit,
		watch,
		trigger,
		register,
		formState: { errors }
	} = useForm({
		mode: 'onChange',
		defaultValues: {
			reason: { value: "", label: "" },
			additional_info: ""
		},
		resolver: yupResolver(completeTaskSchema),
	});

	const onSubmit = async (data: any) => {
		let blockId: any, cardId: any;
		boardData?.map((block: any) => {
			block?.cards.map((card: any) => {
				card?.tasks.map((task: any) => {
					if (task?._id === currentSelectedTask?._id) {
						blockId = block?._id;
						cardId = card?._id
					}
				})
			})
		})
		const payload = {
			"task_id": currentSelectedTask?._id,
			"block_id": blockId,
			"card_id": cardId,
			"additional_info": data?.additional_info,
			is_completed: !currentSelectedTask?.is_completed
		}

		const eventId = currentEventId || id;
		await updateTask(eventId, payload);
		updateBoardCallApiFlag(true);

		setisShowMarkComplete(false);

		const _cardList = [...cardList];
		const copyColumns = [...columns];
		const index = copyColumns.findIndex((col) => col.id === blockId);

		if (index >= 0) {
			copyColumns[index].isSelected = true;

			_cardList.map((item: any) => {
				if (blockId === item.columnId) {
					item.isSelected = copyColumns[index].isSelected;

					item.tasks.map((task: any) => {
						if (task._id === task_id) {
							task.is_completed = true;
						}
					})
				}
			});
		}
		updateState({ column: copyColumns, cards: _cardList });
	};

	const handleChange = (selectedValue: any) => {
		trigger('reason');
		setValue('reason', selectedValue);
		setReasonValue(selectedValue)
	};

	const [additionalInfo, setAdditionalInfo] = useState("");

	const handleAdditionalInfoChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		const newValue = event.target.value;
		setAdditionalInfo(newValue);
		setValue('additional_info', newValue);
	};

	return (
		<>
			<Modal className={"modal-wrapper max-w-[400px]"} isShow={true}>
				<form onSubmit={handleSubmit(onSubmit)}>

					{/* Modal bg Shade */}
					<img className="absolute top-0.5 left-0 object-contain -z-10" src={allImgPaths.backModalShade} alt="shade" />

					<HeaderModal title="" isShowHeader={true} className="modal-header pt-6 px-6 pb-5">
						<div className="flex items-center justify-between">
							<div className='flex justify-center items-center gap-x-4'>
								<img className=" top-0.5 left-0 object-contain -z-10" src={allImgPaths.markcompleteIcon} alt="assign task image" />
							</div>

							{/* Close Icon */}
							<img
								className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
								id="modal-toggle"
								src={allImgPaths.closeIcon}
								alt="close icon"
								onClick={() => setisShowMarkComplete(false)}
							/>
						</div>
						<div className="mt-5">
							<h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1">Mark as complete</h2>
							<p className='text-sm text-[#475467]'>You have chosen to manually mark this task as complete. Please let us know the reason.</p>
						</div>
					</HeaderModal>

					<Body title="" isShowBody={true} className="modal-body px-6 pt-4">
						<div className="mb-10">
							<p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Select the reason
								<span className="text-[#D92D20]">*</span></p>
							<div className="modal-select-box fete-settings-modals adjust-height-modals">
								<CustomDropdown
									name="reason"
									control={control}
									placeholder="Select"
									selectedValue={watch('reason')}
									onChange={handleChange}
									options={
										[
											{ label: "No Longer Required", value: "No Longer Required" },
											{ label: "Already Completed", value: "Already Completed" },
											{ label: "Obsolete Task ", value: "Obsolete Task" }
										]
									}
								/>
								{errors?.reason && (
									<div className='text-red-600'>{errors?.reason.message}</div>
								)}
							</div>
						</div>
						<div className="mb-5">
							<p className="text-[15px] text-[#344054] font-interMedium pb-1.5">Additional information</p>
							<textarea
								className='border border-[#D0D5DD] rounded-lg py-2.5 px-3.5 resize-none w-full placeholder:text-base placeholder:text-[#667085] min-h-28 hover:border-[#1E0AF5] focus-within:border-[#1E0AF5]'
								name="additional_info"
								id=""
								placeholder='Enter here'
								value={additionalInfo}
								onChange={handleAdditionalInfoChange}
							>
							</textarea>
						</div>

					</Body>
					<FooterModal title="" isShowFooter={true} className="modal-footer pt-5 px-6 pb-5">
						<div className="flex items-center gap-x-3 justify-center">
							<button
								type="submit"
								className={`text-[#fff] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 bg-[#1E0AF5] hover:bg-[#120693] ${!reasonValue ? 'button-disabled' : ''}`}
							// onClick={onCloseModal}
							>
								Mark as Complete
							</button>
						</div>
					</FooterModal>
				</form>
			</Modal>
		</>
	)
}

export default MarkComplete